import { InferRequestType, InferResponseType } from "hono/client";
import { client } from "../client";

export const CLUB_INVITATIONS_QUERY_KEY = ["clubInvitations"];
export const USER_CLUBS_QUERY_KEY = ["userClubs"];
export const SENT_INVITATIONS_QUERY_KEY = ["sentInvitations"];
export const CLUB_MEMBERS_QUERY_KEY = ["clubMembers"];
export const LEAVE_CLUB_MUTATION_KEY = ["clubs", "leave"] as const;
export const PATCH_CLUB_MUTATION_KEY = ["clubs", "patch"] as const;
export const CLUB_INSIGHTS_QUERY_KEY = ["clubInsights"];

export type ClubInvitationsResponse = InferResponseType<
  typeof client.clubs.invitations.$get,
  200
>;
export type HandleInvitationRequest = InferRequestType<
  typeof client.clubs.invitations.$patch
>["json"];
export type HandleInvitationResponse = InferResponseType<
  typeof client.clubs.invitations.$patch
>;
export type UserClubsResponse = InferResponseType<typeof client.clubs.$get>;

export type Club = UserClubsResponse[0];

export type SendClubInvitationResponse = InferResponseType<
  typeof client.clubs.invitations.$post
>;

export type CancelClubInvitationResponse = InferResponseType<
  typeof client.clubs.invitations.$delete
>;

export type SentClubInvitation = InferResponseType<
  typeof client.clubs.invitations.sent.$get,
  200
>[0];

export type ClubMembersResponse = InferResponseType<
  typeof client.clubs.members.$get,
  200
>;

export type KickClubMemberRequest = InferRequestType<
  typeof client.clubs.members.$delete
>["query"];

export type KickClubMemberResponse = InferResponseType<
  typeof client.clubs.members.$delete,
  200
>;

export type PromoteToAdminRequest = InferRequestType<
  typeof client.clubs.admins.$post
>["json"];

export type PromoteToAdminResponse = InferResponseType<
  typeof client.clubs.admins.$post,
  200
>;

export type DemoteToMemberRequest = InferRequestType<
  typeof client.clubs.admins.$delete
>["json"];

export type DemoteToMemberResponse = InferResponseType<
  typeof client.clubs.admins.$delete,
  200
>;

export type LeaveClubRequest = InferRequestType<
  typeof client.clubs.leave.$delete
>["json"];

export type LeaveClubResponse = InferResponseType<
  typeof client.clubs.leave.$delete,
  200
>;

export type PatchClubRequest = InferRequestType<
  (typeof client.clubs)[":clubId"]["$patch"]
>["json"];

export type PatchClubResponse = InferResponseType<
  (typeof client.clubs)[":clubId"]["$patch"],
  200
>;

export type ClubInsightsResponse = InferResponseType<
  typeof client.clubs.insights.$get,
  200
>;
